import { render, staticRenderFns } from "./ForgetForm.vue?vue&type=template&id=6e1e58e7"
import script from "./ForgetForm.vue?vue&type=script&lang=js"
export * from "./ForgetForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports